// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const section = "About__section__OpGby";
export const subtitle = "About__subtitle__QmADW font-faces__atlasGroteskMedium__1ilbx font-faces__atlasGrotesk__rYPJr";
export const paragraph = "About__paragraph__Ek0dl font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const mapWrapper = "About__mapWrapper__Wg7f1";